import { v4 as uuidv4 } from 'uuid';

const uniqid = (prefix = '', suffix = '') => {
  return prefix + uuidv4().replace(/-/g, '').slice(0, 18) + suffix;
};

uniqid.process = (prefix = '', suffix = '') => uniqid(prefix, suffix);
uniqid.time = (prefix = '', suffix = '') => uniqid(prefix, suffix);

export default uniqid;
